import { Component } from 'shimmer'

import { Renderer } from './Renderer'

import {
  Scene,
  Vector3,
  Vector2,
  AxesHelper,
} from 'three'

import { PerspectiveCamera } from '@/webGL/cameras'

class WebGL extends Component {
  constructor () {
    super()

    this.resize = this.resize.bind(this)

    this.scene = new Scene()
    this.objectScene = new Scene()

    this.camera = new PerspectiveCamera(50, 1, 1, 500)
    this.camera.far = 2000
    this.camera.setFocalLength(200)
    this.camera.lookAt( new Vector3(0, 0, 0) )

    this.renderer = new Renderer(this.scene, this.camera, this.objectScene)
    this.start()
  }

  onUpdate () {
    this.camera.update()
    this.renderer.render()
  }

  start () {
    this.resize()
  }

  resize (args = {}) {
    args.width = args.width !== void 0 ? args.width : window.innerWidth
    args.height = args.height !== void 0 ? args.height : window.innerHeight
    this.camera.updateMatrixWorld(true)
    this.renderer.resize(args)
  }

  destroy () {
    this.renderer.destroy()
  }

  set baseEl (el) {
    this.baseContainer = el
    this.baseContainer.appendChild(this.renderer.baseCanvas)
  }

  set objectEl (el) {
    this.objectContainer = el
    this.objectContainer.appendChild(this.renderer.objectCanvas)
  }
}

export const webGL = new WebGL()